var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirGapValveSoftenerOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 209,
    height: 197,
    viewBox: "0 0 209 197",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ON",
    transform: "translate(0 -0.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9862",
    "data-name": "Group 9862",
    transform: "translate(24.03 169.989)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3888",
    "data-name": "Path 3888",
    d: "M31.8,197a7.785,7.785,0,0,1-7.77-7.79V172.57a2.59,2.59,0,1,1,5.18,0v16.641a2.6,2.6,0,0,0,2.59,2.6h0l174.6-.17h0a2.6,2.6,0,0,1,0,5.2Z",
    transform: "translate(-24.03 -169.98)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9864",
    "data-name": "Group 9864",
    transform: "translate(23.68 0.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9863",
    "data-name": "Group 9863",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3889",
    "data-name": "Path 3889",
    d: "M26.27,113.246a2.593,2.593,0,0,1-2.59-2.6V2.6a2.59,2.59,0,1,1,5.18,0V110.656a2.591,2.591,0,0,1-2.59,2.59Z",
    transform: "translate(-23.68 -0.01)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9867",
    "data-name": "Group 9867",
    transform: "translate(15.98 15.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9865",
    "data-name": "Group 9865",
    transform: "translate(1.22 0.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3890",
    "data-name": "Path 3890",
    d: "M17.2,38.611l7.43-11.041L17.2,16.52H35.34l-7.43,11.051,7.43,11.041Z",
    transform: "translate(-17.2 -16.52)",
    fill: "#ff16e3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9866",
    "data-name": "Group 9866"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3891",
    "data-name": "Path 3891",
    d: "M34.13,17.17,30.2,23l-3.07,4.56,3.07,4.56,3.93,5.83H18.43l3.93-5.83,3.07-4.56L22.36,23l-3.93-5.83h15.7m2.43-1.3H15.98l1.36,2.03,3.93,5.83,2.58,3.83-2.58,3.83-3.93,5.83-1.36,2.03H36.56L35.2,37.221l-3.93-5.83-2.58-3.83,2.58-3.83L35.2,17.9Z",
    transform: "translate(-15.98 -15.87)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9912",
    "data-name": "Group 9912",
    transform: "translate(0 110.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9868",
    "data-name": "Group 9868",
    transform: "translate(9.308 14.991)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3892",
    "data-name": "Path 3892",
    d: "M42.811,124.99v40.2a5.354,5.354,0,0,1-5.17,5.51H15.78a5.347,5.347,0,0,1-5.17-5.51v-40.2",
    transform: "translate(-9.308 -124.99)",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3893",
    "data-name": "Path 3893",
    d: "M37.64,172H15.78a6.649,6.649,0,0,1-6.47-6.81v-40.2H11.9v40.2a4.06,4.06,0,0,0,3.88,4.21H37.64a4.06,4.06,0,0,0,3.88-4.21v-40.2h2.59v40.2A6.656,6.656,0,0,1,37.64,172Z",
    transform: "translate(-9.308 -124.99)",
    fill: "#00c7b3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9909",
    "data-name": "Group 9909",
    transform: "translate(15.41 19.101)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9870",
    "data-name": "Group 9870",
    transform: "translate(0.88 31.152)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9869",
    "data-name": "Group 9869",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3894",
    "data-name": "Path 3894",
    d: "M17.59,162.85a1.3,1.3,0,1,0-1.3-1.3A1.3,1.3,0,0,0,17.59,162.85Z",
    transform: "translate(-16.29 -160.25)",
    fill: "#00c7b3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9872",
    "data-name": "Group 9872",
    transform: "translate(6.35 28.681)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9871",
    "data-name": "Group 9871",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3895",
    "data-name": "Path 3895",
    d: "M23.06,160.38a1.3,1.3,0,1,0-1.3-1.3,1.3,1.3,0,0,0,1.3,1.3Z",
    transform: "translate(-21.76 -157.78)",
    fill: "#00c7b3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9874",
    "data-name": "Group 9874",
    transform: "translate(11.291 32.042)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9873",
    "data-name": "Group 9873",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3896",
    "data-name": "Path 3896",
    d: "M28,163.74a1.3,1.3,0,1,0-1.3-1.3,1.3,1.3,0,0,0,1.3,1.3Z",
    transform: "translate(-26.7 -161.14)",
    fill: "#00c7b3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9876",
    "data-name": "Group 9876",
    transform: "translate(16.76 27.971)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9875",
    "data-name": "Group 9875",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3897",
    "data-name": "Path 3897",
    d: "M33.47,159.67a1.3,1.3,0,1,0-1.3-1.3A1.3,1.3,0,0,0,33.47,159.67Z",
    transform: "translate(-32.17 -157.07)",
    fill: "#00c7b3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9878",
    "data-name": "Group 9878",
    transform: "translate(20.64 31.862)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9877",
    "data-name": "Group 9877",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3898",
    "data-name": "Path 3898",
    d: "M37.35,163.56a1.3,1.3,0,1,0-1.3-1.3A1.3,1.3,0,0,0,37.35,163.56Z",
    transform: "translate(-36.05 -160.96)",
    fill: "#00c7b3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9880",
    "data-name": "Group 9880",
    transform: "translate(20.999 22.301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9879",
    "data-name": "Group 9879",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3899",
    "data-name": "Path 3899",
    d: "M37.71,154a1.3,1.3,0,1,0-1.3-1.3,1.3,1.3,0,0,0,1.3,1.3Z",
    transform: "translate(-36.41 -151.4)",
    fill: "#00c7b3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9882",
    "data-name": "Group 9882",
    transform: "translate(13.06 22.481)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9881",
    "data-name": "Group 9881",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3900",
    "data-name": "Path 3900",
    d: "M29.77,154.18a1.3,1.3,0,1,0-1.3-1.3A1.3,1.3,0,0,0,29.77,154.18Z",
    transform: "translate(-28.47 -151.58)",
    fill: "#00c7b3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9884",
    "data-name": "Group 9884",
    transform: "translate(6.7 21.061)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9883",
    "data-name": "Group 9883",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3901",
    "data-name": "Path 3901",
    d: "M23.41,152.76a1.3,1.3,0,1,0-1.3-1.3,1.3,1.3,0,0,0,1.3,1.3Z",
    transform: "translate(-22.11 -150.16)",
    fill: "#00c7b3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9886",
    "data-name": "Group 9886",
    transform: "translate(1.409 22.481)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9885",
    "data-name": "Group 9885",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3902",
    "data-name": "Path 3902",
    d: "M18.12,154.18a1.3,1.3,0,1,0-1.3-1.3A1.3,1.3,0,0,0,18.12,154.18Z",
    transform: "translate(-16.82 -151.58)",
    fill: "#00c7b3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9888",
    "data-name": "Group 9888",
    transform: "translate(3.7 14.161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9887",
    "data-name": "Group 9887",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3903",
    "data-name": "Path 3903",
    d: "M20.41,145.86a1.3,1.3,0,1,0-1.3-1.3,1.3,1.3,0,0,0,1.3,1.3Z",
    transform: "translate(-19.11 -143.26)",
    fill: "#00c7b3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9890",
    "data-name": "Group 9890",
    transform: "translate(10.941 10.271)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9889",
    "data-name": "Group 9889",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3904",
    "data-name": "Path 3904",
    d: "M27.65,141.97a1.3,1.3,0,1,0-1.3-1.3A1.3,1.3,0,0,0,27.65,141.97Z",
    transform: "translate(-26.35 -139.37)",
    fill: "#00c7b3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9892",
    "data-name": "Group 9892",
    transform: "translate(10.941 16.821)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9891",
    "data-name": "Group 9891",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3905",
    "data-name": "Path 3905",
    d: "M27.65,148.52a1.3,1.3,0,1,0-1.3-1.3A1.3,1.3,0,0,0,27.65,148.52Z",
    transform: "translate(-26.35 -145.92)",
    fill: "#00c7b3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9894",
    "data-name": "Group 9894",
    transform: "translate(16.94 16.461)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9893",
    "data-name": "Group 9893",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3906",
    "data-name": "Path 3906",
    d: "M33.65,148.16a1.3,1.3,0,1,0-1.3-1.3,1.3,1.3,0,0,0,1.3,1.3Z",
    transform: "translate(-32.35 -145.56)",
    fill: "#00c7b3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9896",
    "data-name": "Group 9896",
    transform: "translate(19.94 11.151)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9895",
    "data-name": "Group 9895",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3907",
    "data-name": "Path 3907",
    d: "M36.65,142.85a1.3,1.3,0,1,0-1.3-1.3A1.3,1.3,0,0,0,36.65,142.85Z",
    transform: "translate(-35.35 -140.25)",
    fill: "#00c7b3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9898",
    "data-name": "Group 9898",
    transform: "translate(0.88 7.79)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9897",
    "data-name": "Group 9897",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3908",
    "data-name": "Path 3908",
    d: "M17.59,139.49a1.3,1.3,0,1,0-1.3-1.3A1.3,1.3,0,0,0,17.59,139.49Z",
    transform: "translate(-16.29 -136.89)",
    fill: "#00c7b3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9900",
    "data-name": "Group 9900",
    transform: "translate(6.7 3.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9899",
    "data-name": "Group 9899",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3909",
    "data-name": "Path 3909",
    d: "M23.41,134.71a1.3,1.3,0,1,0-1.3-1.3,1.3,1.3,0,0,0,1.3,1.3Z",
    transform: "translate(-22.11 -132.11)",
    fill: "#00c7b3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9902",
    "data-name": "Group 9902",
    transform: "translate(14.999 4.96)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9901",
    "data-name": "Group 9901",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3910",
    "data-name": "Path 3910",
    d: "M31.71,136.66a1.3,1.3,0,1,0-1.3-1.3A1.3,1.3,0,0,0,31.71,136.66Z",
    transform: "translate(-30.41 -134.06)",
    fill: "#00c7b3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9904",
    "data-name": "Group 9904",
    transform: "translate(19.409 0.89)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9903",
    "data-name": "Group 9903",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3911",
    "data-name": "Path 3911",
    d: "M36.12,132.59a1.3,1.3,0,1,0-1.3-1.3,1.3,1.3,0,0,0,1.3,1.3Z",
    transform: "translate(-34.82 -129.99)",
    fill: "#00c7b3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9906",
    "data-name": "Group 9906",
    transform: "translate(11.819)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9905",
    "data-name": "Group 9905",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3912",
    "data-name": "Path 3912",
    d: "M28.53,131.7a1.3,1.3,0,1,0-1.3-1.3A1.3,1.3,0,0,0,28.53,131.7Z",
    transform: "translate(-27.23 -129.1)",
    fill: "#00c7b3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9908",
    "data-name": "Group 9908",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9907",
    "data-name": "Group 9907"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3913",
    "data-name": "Path 3913",
    d: "M16.71,131.7a1.3,1.3,0,1,0-1.3-1.3A1.3,1.3,0,0,0,16.71,131.7Z",
    transform: "translate(-15.41 -129.1)",
    fill: "#00c7b3"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9910",
    "data-name": "Group 9910",
    transform: "translate(17.711)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3914",
    "data-name": "Path 3914",
    d: "M18.03,121.261v-5.75a5.181,5.181,0,0,1,5.17-5.19h7a5.175,5.175,0,0,1,5.17,5.19v5.75",
    transform: "translate(-17.711 -110)",
    fill: "#00c7b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3915",
    "data-name": "Path 3915",
    d: "M35.71,121.261h-.65v-5.75a4.863,4.863,0,0,0-4.85-4.86h-7a4.863,4.863,0,0,0-4.85,4.86v5.75h-.65v-5.75a5.512,5.512,0,0,1,5.5-5.51h7a5.512,5.512,0,0,1,5.5,5.51Z",
    transform: "translate(-17.711 -110)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9911",
    "data-name": "Group 9911",
    transform: "translate(0 7.84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3916",
    "data-name": "Path 3916",
    d: "M0,125.42H45.37a2.868,2.868,0,0,0,2.86-2.87v-1.51a2.862,2.862,0,0,0-2.86-2.87H0",
    transform: "translate(0 -117.84)",
    fill: "#00c7b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3917",
    "data-name": "Path 3917",
    d: "M45.37,125.75H0v-.65H45.37a2.546,2.546,0,0,0,2.54-2.55v-1.51a2.552,2.552,0,0,0-2.54-2.55H0v-.65H45.37a3.2,3.2,0,0,1,3.19,3.2v1.51a3.2,3.2,0,0,1-3.19,3.2Z",
    transform: "translate(0 -117.84)",
    fill: "#404041"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirGapValveSoftenerOn);
export default __webpack_public_path__ + "static/media/air_gap_valve_softener_on.d2eae211b5799c8d9cd0c01fe6355baa.svg";
export { ForwardRef as ReactComponent };